import React from 'react'

const FintechComp = () => {
  return (
    <section id="c-sectionFintech" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold"><span className="c-colorFinOrange">Fintech</span> meets your need Best</h5>
				<p className="c-para22Regular text-justify">Finayo is adding speed, security, credit decision in minutes and scale to financial institutions. Our advanced B2B SaaS lending technology connects lenders & OEMs to provide financing in minutes for their customers.</p>
			</div>
			
			<div id="c-fintechWrapper">
				<div className="row">				  
					  <div className="col-md-6 col-lg-6 col-12 c-fintechImgWrapper">
						<div className="tab-content c-customVNavPillsContent" id="v-pills-tabContent">
						  <div className="tab-pane fade show active" id="v-pills-01-fintech" role="tabpanel" aria-labelledby="v-pills-01-fintech">
							<img src="./images/home/fintech/end-end_digital-lending.png" className="img-fluid c-customVNavPillsContentImg"  alt="" title="" />
							<img src="./images/home/fintech/fintech_tabs_bg.png" className="img-fluid c-customVNavPillsContentBg" alt="" title="" />
							
						  </div>
						  <div className="tab-pane fade" id="v-pills-02-fintech" role="tabpanel" aria-labelledby="v-pills-01-fintech">
							<img src="./images/home/fintech/in-minute.png" className="img-fluid c-customVNavPillsContentImg" alt="" title="" />
							<img src="./images/home/fintech/fintech_tabs_bg.png" className="img-fluid c-customVNavPillsContentBg" alt="" title="" />
						  </div>
						  <div className="tab-pane fade" id="v-pills-03-fintech" role="tabpanel" aria-labelledby="v-pills-03-fintech">
							<img src="./images/home/fintech/secure-profile.png" className="img-fluid c-customVNavPillsContentImg" alt="" title="" />
							<img src="./images/home/fintech/fintech_tabs_bg.png" className="img-fluid c-customVNavPillsContentBg" alt="" title="" />
						  </div>
						  <div className="tab-pane fade" id="v-pills-04-fintech" role="tabpanel" aria-labelledby="v-pills-04-fintech">
							<img src="./images/home/fintech/papperless.png" className="img-fluid c-customVNavPillsContentImg" alt="" title="" />
							<img src="./images/home/fintech/fintech_tabs_bg.png" className="img-fluid c-customVNavPillsContentBg" alt="" title="" />
						  </div>
						  <div className="tab-pane fade" id="v-pills-05-fintech" role="tabpanel" aria-labelledby="v-pills-04-fintech">
							<img src="./images/home/fintech/troble-free.png" className="img-fluid c-customVNavPillsContentImg" alt="" title="" />
							<img src="./images/home/fintech/fintech_tabs_bg.png" className="img-fluid c-customVNavPillsContentBg" alt="" title="" />
						  </div>
						</div>
					  </div>
					  <div className="col-md-6 col-lg-6 col-12 c-fintechTabsWrapper">
						<div className="nav flex-column nav-pills c-customVNavPills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
						  <div className="nav-link active" id="v-pills-01-fintech" data-toggle="pill" href="#v-pills-01-fintech" role="tab" aria-controls="v-pills-01-fintech" aria-selected="true">
							<div className="c-customVNavPillsSrNo">01</div>
							<div className="c-customVNavPillsInfo">
								<div className="c-customVNavPillsTitle">End-to-End Digital Lending </div>
								<p>An automated loan consent procedure that allows lenders to ensure more accuracy.</p>	
								<div className="c-customVNavPillsInfoImg">
									<img src="images/home/fintech/fintech_1.png" className="img-fluid c-customVNavPillsContentImg"  alt="" title="" />
								</div>							
							</div>							
						  </div>
						  <div className="nav-link" id="v-pills-02-fintech" data-toggle="pill" href="#v-pills-02-fintech" role="tab" aria-controls="v-pills-02-fintech" aria-selected="false">
							<div className="c-customVNavPillsSrNo">02</div>
							<div className="c-customVNavPillsInfo">
								<div className="c-customVNavPillsTitle">Finance in minutes </div>
								<p>To eliminate human error, make your loan an automated payment.</p>
								<div className="c-customVNavPillsInfoImg">
									<img src="./images/home/fintech/in-minute.png" className="img-fluid c-customVNavPillsContentImg"  alt="" title="" />
								</div>
							</div>
						  </div>
						  <div className="nav-link" id="v-pills-03-fintech" data-toggle="pill" href="#v-pills-03-fintech" role="tab" aria-controls="v-pills-03-fintech" aria-selected="false">
							<div className="c-customVNavPillsSrNo">03</div>
							<div className="c-customVNavPillsInfo">
								<div className="c-customVNavPillsTitle">Lend more secure profiles</div>
								<p>On a single platform, lending brings together alternative investment options and is creditworthy. </p>
								<div className="c-customVNavPillsInfoImg">
									<img src="./images/home/fintech/secure-profile.png" className="img-fluid c-customVNavPillsContentImg"  alt="" title="" />
								</div>
							</div>
						  </div>
						  <div className="nav-link" id="v-pills-04-fintech" data-toggle="pill" href="#v-pills-04-fintech" role="tab" aria-controls="v-pills-04-fintech" aria-selected="false">
							<div className="c-customVNavPillsSrNo">04</div>
							<div className="c-customVNavPillsInfo">
								<div className="c-customVNavPillsTitle">Paperless Approach </div>
								<p>Quick action for identifying and authenticating customers to access multiple banking services.</p>
								<div className="c-customVNavPillsInfoImg">
									<img src="./images/home/fintech/papperless.png" className="img-fluid c-customVNavPillsContentImg"  alt="" title="" />
								</div>
							</div>
						  </div>
						  <div className="nav-link" id="v-pills-03-fintech" data-toggle="pill" href="#v-pills-05-fintech" role="tab" aria-controls="v-pills-03-fintech" aria-selected="false">
							<div className="c-customVNavPillsSrNo">05</div>
							<div className="c-customVNavPillsInfo">
								<div className="c-customVNavPillsTitle">Trouble-free reach</div>
								<p>Online banking allows customers to manage their finances with ease.</p>
								<div className="c-customVNavPillsInfoImg">
									<img src="./images/home/fintech/troble-free.png" className="img-fluid c-customVNavPillsContentImg"  alt="" title="" />
								</div>
							</div>
						  </div>
						</div>
					  </div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default FintechComp